import moment from 'moment';

moment.locale('es');

export default (function (ctx, inject) {
    inject('moment', moment);
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/moment.js
// module id = ./src/plugins/moment.js
// module chunks = 34